<div class="device-stepper-modal">
    <app-tab-stepper-modal  [isDashboard]="true" [dataTypeTree]="dataTypeTree"
        (generatedChart)="generateChart($event)" (periodEmitter)="getPeriod($event)"
        (dataWidgetFromTabStepper)="addWidget($event)"
        (choseData) = "choseData($event)"      
        >
    </app-tab-stepper-modal>
</div>